/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { OverlayRef } from "@angular/cdk/overlay";

import { NzSafeAny } from "ng-zorro-antd/core/types";

import { UiModalOptions } from "../modal.models";
import { BaseModalContainerComponent, NzModalRef } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class UiModalRef<T = NzSafeAny, R = NzSafeAny> extends NzModalRef {
  constructor(modalOverlayRef: OverlayRef, modalConfig: UiModalOptions, public containerInstance: BaseModalContainerComponent) {
    super(modalOverlayRef, TransformModalOptions(modalConfig), containerInstance);
  }
}
